export const execute = (provider) => () => {
    return provider.getAll()
    .then(sort)
}

const sort = (services) => {
    return services.sort((s1, s2) => s1.name.toLowerCase() > s2.name.toLowerCase() ? 1 : -1);
}
